import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Select, Collapse,Space,DatePicker, Typography } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { Tabs } from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import EditCharger from './EditCharger';
import { GrStatusGoodSmall } from "react-icons/gr";
import { DownloadOutlined } from '@ant-design/icons';
import { HiRefresh } from "react-icons/hi";
import { FaShieldAlt } from "react-icons/fa";
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import { useWebSocket } from '../../Utils/WebSocketContext';
import { TiWarningOutline } from "react-icons/ti";
import { GrPowerReset } from "react-icons/gr";


const LocationChargers = ({ location }) => {
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [isDeleteChargerModalVisible, setIsDeleteChargerModalVisible] = useState(false);
    const [chargerToDelete, setChargerToDelete] = useState(null);
        const [downtimeCsvDownloadData,setDowntimeCsvDownloadData] = useState({fromDate:null,toDate:null,selectedChargers:[]})
    
        const [downloadFile,setDownloadFile] = useState(false);
        const [isCSVLoading, setIsCSVLoading] = useState({downtimeReport:false})
    
    const [forceDeleteText, setForceDeleteText] = useState('');

    const [isResetChargerModalVisible, setIsResetChargerModalVisible] = useState(false);
        const [chargerToReset, setChargerToReset] = useState(null);
        const [resetType, setResetType] = useState(null);
        const [resetConfirmText, setResetConfirmText] = useState(null);
    
        const [isResetting, setIsResetting] = useState(false);


    const [isLoading, setIsLoading] = useState(true);
    const [chargers, setChargers] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });

    const [isDeleting, setIsDeleting] = useState(false);

    const [chargerToEdit, setChargerToEdit] = useState(null);
    const [isEditChargerModalVisible, setIsEditChargerModalVisible] = useState(false);


    const { TabPane } = Tabs;
    const webSocket = useWebSocket();

    useEffect(()=>{
            // console.log("In websocket useeffect")
            if(webSocket){
                // console.log("websocket connected");
                webSocket.addEventListener('message', function (event) {
                    // console.log("WebSocket event received: ", JSON.parse(event.data).data[0].sampled_value);

                    if(JSON.parse(event.data).type === 'clock.updated'){ 
                        let temp = Number(JSON.parse(event.data).data[0].sampled_value.filter((item) => {
                            return item.measurand === 'Temperature' 
                        })[0].value);
                        // console.log("------temp", temp)
                        // setEventType(JSON.parse(event.data).type)
                        let csms_id = JSON.parse(event.data).data[1].csms_charger_id;
                        
                            setChargers(prevChargers => 
                                    prevChargers.map(charger =>
                                        charger.csmsBreatheChargerID === csms_id
                                            ? { ...charger, temperature: temp}
                                            : charger
                                    )
                                );
                    }
                })
            }
        },[webSocket])
    useEffect(() => {
        if (location) {
            getChargers();
        }
    }, [location]);

    const getChargers = async (page = 1, pageSize = 10) => {
        console.log("Fetching chargers for location: ", location.locationName, " with page: ", page, " and pageSize: ", pageSize);
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getChargerList({ page, limit: pageSize, location_id: location._id });
            console.log("Chargers fetched: ", res.data.chargers);
            setChargers(res.data.chargers);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
            toast.error('Error fetching chargers.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getChargers(current, pageSize);
    };
    const fetchFirmWareVersion = async ()=>{
        try{
            setIsLoading(true)
            let result = await BreathAPIs.getChargerFirmware(location._id)
            console.log("result for firmware: ", result)
            if(result.data?.message == true){
                handleTableChange(pagination)
            }
        }catch(err){
            console.log(err.message)
        }finally{
            setIsLoading(false)
        }
    }
    const checkAvailbility =(chargerAvailability, chargerStatus)=>{
        if (chargerAvailability === true && chargerStatus === "Online"){
            return styles.isGreen
        }
        else if(chargerAvailability === true && chargerStatus === "Offline"){
            return styles.isOrange
        }
        else{
            return styles.isRed
        }
    }
    const disableFutureDates = (current,datePickerType) => {
        if(datePickerType==='dateFrom'){

            return current && current > new Date(); // Disable dates after today
        }
        else{
            
        }
      };

        const handleDownloadFileEnd = ()=>{
              setDownloadFile(false);
              
              setIsCSVLoading({downtimeReport:false});
              setDowntimeCsvDownloadData({fromDate:null,toDate:null,selectedChargers:[]})
          }
          function toLocalISOString(date) {
              const pad = (num) => String(num).padStart(2, '0');
          
              const year = date.getFullYear();
              const month = pad(date.getMonth() + 1); // getMonth() is zero-based
              const day = pad(date.getDate());
              const hours = pad(date.getHours());
              const minutes = pad(date.getMinutes());
              const seconds = pad(date.getSeconds());
              const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
          
          return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
          }
          const jsonToCsv = (json,reportType) => {
      
             
              if(reportType === 'downtimeReport'){
                  
      
                  let csvContent = "";
              
                  // Add grouped documents to the CSV
                  csvContent += "ChargerID,OfflineTimestamp,DownTimeDuration,UpdatedBy,OnlineTimestamp\n";
              
                  json.forEach((item) => {
                      item.groupedDocuments.forEach((doc) => {
                          csvContent += `${doc.charger},${doc.offlineTimestamp},${doc.downTimeDuration},${doc.updatedBy},${doc.onlineTimestamp}\n`;
                      });
                  });
              
                  // Add blank lines to separate the tables
                  csvContent += "\n\n";
              
                  // Add summary fields to the CSV
                  csvContent += "Summary Fields\n";
                  csvContent += "ChargerID,ChargerDowntimeCount,Downtime Duration (> 8 mins),Downtime Duration (5–8 Minutes),AverageDownTimeDuration,StandardDeviationDownTimeDuration\n";
              
                  json.forEach((item) => {
                      csvContent += `${item._id},${item.chargerDowntimeCount},${item.downtimeDurationRedWarning},${item.downtimeDurationYellowWarning},${item.averageDownTimeDuration},${item.standardDeviationDownTimeDuration}\n`;
                  });
      
                  return csvContent
              }
            };
      
           const callDowntimeLambdaFunction = async () => {
                  try {
                      setIsCSVLoading({...isCSVLoading,downtimeReport:true})
          
                  const tempStartDate = downtimeCsvDownloadData.fromDate;
                  const startDate = new Date(tempStartDate.$y,tempStartDate.$M ,tempStartDate.$D,0,0,0);
                  // console.log("startDate",startDate)
                  
                  const tempendDate = downtimeCsvDownloadData.toDate;
                  // console.log("tempendDate",tempendDate)
                  const endDate =new Date(tempendDate.$y,tempendDate.$M ,tempendDate.$D,23,59,59,999);
                  // console.log("endDate",endDate)
          
                  
                  // console.log('StartDate:',toLocalISOString(new Date(startDate)));
                  // console.log('endDate:',toLocalISOString(new Date(endDate)));
                  const result = await BreathAPIs.getDowntimeLambdaData(toLocalISOString(new Date(startDate)),toLocalISOString(new Date(endDate)),downtimeCsvDownloadData.selectedChargers); 
                  // console.log('Downtime Data: ',JSON.stringify(result.data))
                  if(result.data && result.data.length === 0){
                      toast.warn('No data to process in this time frame');
                      setIsCSVLoading({...isCSVLoading,downtimeReport:false})
                      return;
                  }
                  if(result.status !== 200){
                      toast.error('Error generating csv');
                      setIsCSVLoading({...isCSVLoading,downtimeReport:false})
                      return;
                  }
          
                  const csvResponse = jsonToCsv(result.data,'downtimeReport');
          
                  const formattedDate = new Date().toISOString().split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$3-$2');
                    const blob = new Blob([csvResponse], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.setAttribute('href', url);
                    a.setAttribute('download', `${formattedDate}-DowntimeData.csv`);
                    a.click();
                    // Clean up the URL object
                    URL.revokeObjectURL(url);
                    setIsCSVLoading({...isCSVLoading,sessionReport:false})
          
                  } catch (error) {
                    console.error('Error calling AWS Lambda & Report generation:', error);
                    setIsCSVLoading({...isCSVLoading,downtimeReport:false})
                  }
                };

    const columnChargers = [
        {
            title: 'ID',
            dataIndex: '_id',
            key: '_id',
            render: (text, record) => (
                <Typography.Text
                    copyable={{ text: record._id }}
                    style={{ whiteSpace: 'nowrap' }}
                >
                    {record._id?.slice(-7)}...
                </Typography.Text>
            )
        },
        {
            title: 'Charger Name',
            dataIndex: 'chargerTag',
            key: 'chargerTag',
            render: (text, record)=>{
                return (
                <div className={styles.chargerNameStatusFlex}>
                    {/* Status dots */}
                    <div className={styles.statusDotsWrapper}>
                        {record.connector.map((conn, index) => {
                            const availabilityClass = checkAvailbility(conn.connectorAvailability, record.chargerStatus);
                            return (
                                <div key={index} className={`${styles.statusIndicator} ${availabilityClass}`}>
                                    <GrStatusGoodSmall />
                                </div>
                            );
                        })}
                    </div>

                    <div className={styles.chargerTag}>
                        {text}
                    </div>
                </div>
            );
                }
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            render: (location) => location.locationName,
        },
        {
            title: 'Charger Type',
            dataIndex: 'protocol',
            key: 'protocol',
        },
        {
            title: "Temperature (°C)",
            dataIndex: "temperature",
            key: "temperature",
            render: (temp) => temp !== null && temp !== undefined && temp !== 0 ? temp: "N/A"
        },
        {
            title: "Serial Number",
            dataIndex: "ChargePointSerialNumber",
            key: "ChargePointSerialNumber",
            render: (ChargePointSerialNumber) => ChargePointSerialNumber != '' ? ChargePointSerialNumber : "N/A"
        },
        {
            title: "Firmware version",
            dataIndex: "firmwareVersions",
            key: "firmwareVersions",
            render: (firmwareVersions) => firmwareVersions.length != 0 ? Object.keys(firmwareVersions[firmwareVersions.length - 1])[0]: "N/A"
        },
        {
            title: 'Download Report',
            key:'downloadReport',
            render: (text, record) => (
                <Button type="primary" icon={<DownloadOutlined />} onClick={()=>{
                    setDownloadFile(true);setDowntimeCsvDownloadData({...downtimeCsvDownloadData, selectedChargers:[record._id]})
                   
                }} />
            )
        },
        {
            title: '',
            key: 'delete',
            width: 150,
            fixed: 'right',
            render: (text, record) => (
                <>
                    <Button type="Text" shape="circle" danger onClick={() => showChargerEditModal(record)}>
                        <AiFillEdit />
                    </Button>
                    <Button className='ms-2' shape="circle" danger onClick={() => openDeleteChargerModal(record)}>
                        <AiFillDelete />
                    </Button>
                    <Button className='ms-2' shape="circle" onClick={() => setResetCharger(record)}>
                        <GrPowerReset />
                    </Button>
                    
                </>

            ),
        },

        
    ];

    const columnConnector = [
        {
            title: 'Connector Type',
            dataIndex: 'type',
            key: 'type',
          },
          {
            title: 'Power',
            dataIndex: 'power',
            key: 'power',
          },
          {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
          },
          {
            title: "Energy Meter Value (Wh)",
            dataIndex: "meterValue",
            key: "meterValue",
            render: (meterValue) => meterValue !== null && meterValue !== undefined ? meterValue : "N/A"
          }
        ];

    const openDeleteChargerModal = (charger) => {
        setChargerToDelete(charger);
        setIsDeleteChargerModalVisible(true);
    };

    const handleDeleteChargerOk = async () => {
        try {
            if (chargerToDelete) {
                setIsDeleting(true);
                await BreathAPIs.deleteCharger(chargerToDelete._id, forceDeleteText === 'Delete' ? true : false);
                setIsDeleting(false);
                getChargers();
                toast.success('Charger deleted successfully.');
            }
        } catch (error) {
            console.error('Error deleting charger:', error);
            setIsDeleting(false);
            if (error.response && error.response.data && error.response.data.errors) {
                const errorMessage = error.response.data.errors.msg;
                toast.error(errorMessage);
            } else {
                toast.error('Error deleting charger. Please try again later.');
            }
        } finally {
            setIsDeleteChargerModalVisible(false);
            setChargerToDelete(null);
            setForceDeleteText('');
        }
    };

    const handleResetCharger = async () => {
            try{
                setIsResetting(true)
                if(resetConfirmText !== "Confirm"){
                    // setIsResetChargerModalVisible(false);
                    setIsResetting(false);
                    toast.error("Please Confirm Reset")
                    return;
                }
                if(!resetType){
                    // setIsResetChargerModalVisible(false);
                    setIsResetting(false);
                    toast.error("Please Select Reset Type")
                    return;
                }
                if(!chargerToReset.csmsBreatheChargerID){
                    // setIsResetChargerModalVisible(false);
                    setIsResetting(false);
                    toast.error("Please Select Charger")
                    return;
                }
    
                let response = await BreathAPIs.resetCharger(chargerToReset.csmsBreatheChargerID, resetType);
    
                console.log("response for reset: ", response)
    
                if (response.status === 200){
                    toast.success("Charger Reset Requested Successfully")
                    setIsResetChargerModalVisible(false);
                    setIsResetting(false);
                    setChargerToReset(null);
                    setResetType(null);
                    setResetConfirmText(null);
                }
                
            }catch(error){
                setIsResetting(false)
                console.log("error in handleResetCharger",error.message)
                toast.error(error.response.data) 
            }
            // console.log("reset type : ", resetType)
            // console.log("reset confirm text : ", resetConfirmText)
            // console.log("charger to reset : ", chargerToReset.csmsBreatheChargerID)
            // console.log("charger to reset : ", chargerToReset._id)
        }
        
        const setResetCharger = (charger) => {
            setChargerToReset(charger);
            setIsResetChargerModalVisible(true);
        }


    const handleDeleteCancel = () => {
        setIsDeleteModalVisible(false);
        setIsDeleteChargerModalVisible(false);
        setChargerToDelete(null);
        setForceDeleteText('');
    };

    const handleEditChargerCancel = () => {
        setIsEditChargerModalVisible(false);
        setChargerToEdit(null);
    };

    const showChargerEditModal = (charger) => {
        setIsEditChargerModalVisible(true);
        setChargerToEdit(charger);
    };

    return (
        <div className='mt-3'>
            <div className={`${styles.refreshButtondiv}`}>
                <button className={`btn btn-secondary mb-3 ${styles.refreshButtonFirmware}`} onClick={() => fetchFirmWareVersion()}>
                    <FaShieldAlt resh style={{ marginBottom: '-3px' }} />
                </button>
                <button className={`btn btn-secondary mb-3 ${styles.refreshButton}`} onClick={() => handleTableChange(pagination)}>
                    <HiRefresh style={{ marginBottom: '-3px' }} />
                </button>
            </div>
            <Table
                loading={isLoading}
                dataSource={chargers}
                columns={columnChargers}
                expandable={{
                    expandedRowRender: record => (
                        <Table
                            dataSource={record.connector}
                            columns={columnConnector}
                            pagination={false}
                            rowKey="edrvID"
                            className={styles['data-list']}
                            bordered
                            size="middle"
                            scroll={{ x: 'calc(600px + 50%)' }}
                        />
                    )
                }}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                className={styles['data-list']}
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)' }}
            />
            <EditCharger
                modalVisible={isEditChargerModalVisible}
                closeModal={handleEditChargerCancel}
                selCharger={chargerToEdit}
                submitFeedback={(message) => { toast.success(message); handleTableChange(pagination); }}
            />
            <Modal
                title="Confirm Delete"
                open={isDeleteChargerModalVisible}
                onOk={handleDeleteChargerOk}
                onCancel={handleDeleteCancel}
                okText={forceDeleteText == 'Delete' ? 'Force Delete' : 'Delete'}
                confirmLoading={isDeleting}
            >
                <div>
                    Are you sure you want to delete {chargerToDelete ? chargerToDelete.chargerTag : ''}?

                    <div className="mb-3 mt-3">
                        <input type="text" className="form-control" value={forceDeleteText} onChange={(e) => setForceDeleteText(e.target.value)} placeholder="Enter 'Delete' to force delete" />
                    </div>
                </div>
            </Modal>
            <Modal
                title="Download File"
                open={downloadFile}
                onCancel={handleDownloadFileEnd}
                footer={null}
            >
                <Collapse accordion items={[
                                       
                                        {
                                            key: '1',
                                            label: <div style={{fontWeight:500}}>Downtime Report</div>,
                                            children: 
                                            <div>

                                            <div className={styles['download-container']}>
                                            
                              
                                            <Space direction="vertical" size={10} align='center'>
                                            <DatePicker style={{ width: 170 }} value={downtimeCsvDownloadData.fromDate} placeholder='Date From' onChange={(date) => setDowntimeCsvDownloadData({...downtimeCsvDownloadData,fromDate:date})} disabledDate={disableFutureDates}/>
                                            <DatePicker style={{ width: 170 }} value={downtimeCsvDownloadData.toDate} placeholder='Date To'  onChange={(date) => setDowntimeCsvDownloadData({...downtimeCsvDownloadData,toDate:date})}  disabledDate={(current) =>
                                                              current &&
                                                              (current > new Date() || (downtimeCsvDownloadData.fromDate && current < downtimeCsvDownloadData.fromDate))
                                                            }/>
                                            </Space>
                                            {/* <Divider style={{borderColor:'#dbd7d7',height: 'auto'}} type = 'vertical' /> */}
                                           
                                          
                                            </div>
                                            <div className={styles['download-button']}>
                                                <ButtonCustom isLoading={isCSVLoading.downtimeReport} disabled={isCSVLoading.downtimeReport || downtimeCsvDownloadData.toDate === null || downtimeCsvDownloadData.fromDate === null} onClick={() => {callDowntimeLambdaFunction()}} style={{height:'100%',width:'max-content',padding: 3.5 + 'px'}} text={"Generate Downtime Report"} ></ButtonCustom>
                                            </div>
                                            
                                         </div>
                                        },
                                       
                                        ]} />
                             
            


            </Modal>

            {
                            isResetChargerModalVisible && 
                            <Modal
                            title="Reset Charger"
                            open={isResetChargerModalVisible}
                            onCancel={
                                ()=>{
                                    setIsResetChargerModalVisible(false);
                                    setChargerToReset(null);
                                    setResetType(null);
                                    setResetConfirmText(null);
                                }
                            }
                            footer={null}>
            
                                <p>Are you sure you want to reset <b>{chargerToReset?.chargerTag}?</b></p>
                                <p><TiWarningOutline color='#fab00f'/>this action may affect ongoing sessions in the current charger.</p>
            
            
                               <Select 
                                    placeholder={'Select Reset Type'}
                                        style={{ width: '100%' }}
                                    allowClear
                                    value={resetType}
                                        options={[{value:'soft',label:'Soft Reset'},{value:'hard',label:'Hard Reset'}]}
                                        onChange={(value) => { setResetType(value) }}
                                        onClear={() => setResetType(null)}
                                    />
            
                                <Input
                                    placeholder={'Enter "Confirm" to reset charger'}
                                        style={{ width: '100%' }}
                                    allowClear
                                    value={resetConfirmText}
                                        onChange={(e) => { setResetConfirmText(e.target.value) }}
                                        onClear={() => setResetConfirmText(null)}
                                    />
                                
                                <ButtonCustom
                                    text="Reset Charger"
                                    onClick={handleResetCharger}
                                    isLoading={isResetting}
                                    disabled={isResetting || !resetType || resetConfirmText !== 'Confirm'}
                                />
            
                                {/* <p>{chargerToReset?.csmsBreatheChargerID}</p> */}
                                
            
                            </Modal>
                        }
        </div>
    );
};


export default LocationChargers;
